
import { observable, action, computed, toJS } from 'mobx';


import _ from "lodash"


import axios from 'axios';

import { API_URL } from '../config'

import { races, raceIn } from "../services/MainServices"

import { dateFormatedYMD } from "../helper";
import { act } from 'react-dom/test-utils';

class HourseBet {

    constructor() {
        this.init()
    }

    @observable data = []
    @observable loading = false
    @observable initAfterLoad = false
    @observable token = localStorage.getItem('token');
    @observable coupons = []
    @observable couponsReport = []
    @observable minCouponPrice = 5
    @observable maxCouponPrice = 5000
    @observable checkInit = false
    @observable avaiableBahisler = [
    ]
    @observable avaiableBahislerAll = [
        { "text": "Ganyan", "value": "ganyan", "aprice": 1 },
        { "text": "Çifte Bahis", "value": "cifte_bahis", "aprice": 1 },
        { "text": "İkili Bahis", "value": "ikili_bahis", "aprice": 1 },
        { "text": "3'lü Ganyan", "value": "3_lu_ganyan", "aprice": 0.25 },
        { "text": "4'lü Ganyan", "value": "4_lu_ganyan", "aprice": 0.15 },
        { "text": "5'li Ganyan", "value": "5_li_ganyan", "aprice": 0.08, "group": { "a": ["ELAZIG", "SANLIURFA", "DIYARBAKIR"], "aprice": 0.06 } },
        { "text": "6'lı Ganyan", "value": "6_li_ganyan", "aprice": 0.08, "group": { "a": ["ELAZIG", "SANLIURFA", "DIYARBAKIR"], "aprice": 0.06 } },
        { "text": "Tabela Bahis", "value": "tabela_bahis", "aprice": 0.15 },
        { "text": "7'li Plase", "value": "7_li_plase", "aprice": 0.10 },
        { "text": "Sıralı İkili Bahis", "value": "sirali_ikili_bahis", "aprice": 1 },
        { "text": "Sıralı Üçlü Bahis", "value": "sirali_uclu_bahis", "aprice": 0.25 }
    ]
    @observable couponTypes = [
        { "text": "Kazanan", "value": 1, },
        { "text": "Kaybeden", "value": 0, },
        { "text": "Bekleniyor", "value": 2, },
    ]


    //ilk kontroller
    @action init() {
        if (!this.checkInit) {
            this.getMyLocalSettings()
        }
    }

    @computed get getAvaiableBahisAll() {
        return this.avaiableBahislerAll
    }
    @computed get getAvaiableBahis() {
        return this.avaiableBahisler
    }

    @action async getMyLocalSettings() {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${API_URL}/get-global-settings`;
                let mySettings = await axios.get(url, this.getHeader())
                mySettings = mySettings.data
                let checkedList = _.get(mySettings, "checkedList", [])
                console.log({
                    mySettings
                })
                const pusht = []
                this.avaiableBahislerAll.map(v => {
                    if (_.includes(checkedList, v.value)) {
                        // console.log("***************************************************", { v: toJS(v) })
                        pusht.push(v)
                    }
                    /*
                    if(_.find(checkedList,(o)=>{
                        return _
                    }))
                    */
                })
                this.avaiableBahisler = pusht
                this.minCouponPrice = mySettings.minCouponPrice
                this.maxCouponPrice = mySettings.maxCouponPrice

                //  _.get(mySettings,"checkedList",[])
            } catch (error) {
                console.log("err", { error })
                this.resetMySettings()
                return reject(error)
            }
        })
    }

    @action resetMySettings() {
        this.avaiableBahisler = this.avaiableBahislerAll
    }

    @action async getmainDataInServer() {
        const myDate = dateFormatedYMD(Date.now())
        const url = `${API_URL}/public/get-hourse-main/${myDate}`;
        return axios.get(url)
    }
    // ana daga getir v1
    @action async getmainDataInServerV1() {
        const myDate = dateFormatedYMD(Date.now())
        let url = `${API_URL}/public/get-hourse-main-v/${myDate}`;
        return axios.get(url)
    }

    // ana data getir v3
    @action async getmainDataInServerV2() {
        const myDate = dateFormatedYMD(Date.now())
        let url = `${API_URL}/public/get-hourse-main-v3/${myDate}`;
        return axios.get(url, this.getHeader())
    }

    // programı getir
    @action async getProgram(date) {

        //  date = new Date().setDate(date)

        const myDate = dateFormatedYMD(date ? new Date().setDate(date) : Date.now())
        console.log("getProgram", { date, myDate })
        let url = `${API_URL}/public/get-program/${myDate}`;
        return axios.get(url)
    }


    //kupon yap
    @action saveCoupon(data) {
        return new Promise((resolve, reject) => {
            const url = `${API_URL}/bet/hourse`
            axios.post(url, data, this.getHeader()).then((res) => {
                return resolve(res.data)
            }).catch((err) => {
                return reject(err)
            })
        })
    }


    //kuponları listele
    @action listCoupon(obj) {

        // let u = new URLSearchParams(obj).toString();
        //  console.log("listCoupon", u);

        let urlParameters = obj ? Object.entries(obj).map(e => e.join('=')).join('&') : ""
        //  console.log(urlParameters);
        this.loading = true
        return new Promise((resolve, reject) => {
            const url = `${API_URL}/bet/hourse?${urlParameters}`
            axios.get(url, this.getHeader()).then((res) => {
                this.coupons = res.data
                return resolve(res.data)
            }).catch((err) => {
                return reject(err)
            }).finally(() => {
                this.loading = false
            })
        })
    }

    //kuponları listele -- RAPOR
    @action listCouponReport(obj) {

        // let u = new URLSearchParams(obj).toString();
        //  console.log("listCoupon", u);

        let urlParameters = obj ? Object.entries(obj).map(e => e.join('=')).join('&') : ""
        //  console.log(urlParameters);
        this.loading = true
        return new Promise((resolve, reject) => {
            const url = `${API_URL}/bet/hourse/report?${urlParameters}`
            axios.get(url, this.getHeader()).then((res) => {
                //  res.data[0].user.workType = 0
                this.couponsReport = res.data
                return resolve(res.data)
            }).catch((err) => {
                return reject(err)
            }).finally(() => {
                this.loading = false
            })
        })
    }

    //kuponları listele --GÜNLÜK RAPOR
    @action listCouponReportDay(obj) {

        let urlParameters = obj ? Object.entries(obj).map(e => e.join('=')).join('&') : ""
        //  console.log(urlParameters);
        this.loading = true
        return new Promise((resolve, reject) => {
            const url = `${API_URL}/bet/hourse/report-day?${urlParameters}`
            axios.get(url, this.getHeader()).then((res) => {
                //  res.data[0].user.workType = 0
                this.couponsReportDay = res.data
                return resolve(res.data)
            }).catch((err) => {
                return reject(err)
            }).finally(() => {
                this.loading = false
            })
        })
    }




    //kupon sil
    @action remove(data) {
        this.loading = true
        return new Promise((resolve, reject) => {
            const url = `${API_URL}/bet/hourse/cancel`
            axios.post(url, data, this.getHeader()).then((res) => {
                //    this.coupons = res.data
                return resolve(res.data)
            }).catch((err) => {
                return reject(err)
            }).finally(() => {
                this.loading = false
            })
        })
    }

    //kupon local ekle
    @action push(item) {
        this.coupons.push(item)
        this.setCoupons()
    }

    //kupon local sil
    @action splice(id) {
        const index = this.coupons.findIndex(v => v._id === id);

        if (index !== -1) {
            this.coupons.splice(index, 1)
            this.setCoupons()
            return
        }
    }

    //set ant listele
    @action setCoupons() {
        this.coupons = _.orderBy(this.coupons, ['created'], ['desc'])
        //   this.coupons = this.coupons
    }





    //yarış listesi  DATA
    @action async getRaceList(date = null) {
        this.loading = true
        const myDate = dateFormatedYMD(Date.now())
        let url = `${API_URL}/public/get-races/${myDate}`;
        try {
            const serverData = await axios.get(url);
            console.log({ serverData })
            this.races = _.get(serverData, "data", [])

        } catch (error) {
            console.log({ error })
        }
        finally {
            this.getRaces()
        }

    }

    //yarışları getir  DATA
    @action getRaces() {
        ///public/get-race-in/:date/:KEY
        const myDate = dateFormatedYMD(Date.now())
        this.races.map(async v => {
            console.log("//////////")
            let url = `${API_URL}/public/get-race-in/${myDate}/${v.KEY}`;
            try {
                const serverData = await axios.get(url);
                console.log({ serverData })
                // this.raceIn = this.raceIn.concat(_.get(serverData,"data",[]))
                this.raceIn.push(_.get(serverData, "data", []))
                this.raceIn = this.raceIn
            } catch (error) {
                console.log({ error })
            }
            finally {
                this.loading = false
                this.initAfterLoad = true
            }
        })
    }

    //sonuçları getir
    @action getResult(formatedDate) {
        let url = `${API_URL}/public/get-result/${formatedDate}`;
        return axios.get(url)
    }



    //logları listele
    @action async getLogs(date = null) {
        let url = `${API_URL}/logs${date ? `?date=${date}` : ""}`;
        return axios.get(url, this.getHeader());
    }


    getHeader() {
        return { headers: { Authorization: this.token, 'Content-Type': 'application/json' } }
    }



}
export default HourseBet;
